export const HOME_ROUTE = 'pagina-inicial';

export const HOME_EXCLUDED_LINKS = new Set([
  'registro-confirmacao',
  'operacoes-confirmacao',
]);

/** Títulos das colunas da home (podem divergir do label do menu lateral). */
export const HOME_COLUMN_TITLES: Record<string, string> = {
  'credit-operations': 'Operações e consultas de crédito de carbono',
  'projects-emission': 'Registro de projetos e emissão de créditos',
};

export const HOME_LINK_PRESENTATION: Record<string, { icon: string; label?: string }> = {
  'registro-credito': { icon: 'description' },
  'operacao-transferencia': { icon: 'sync_alt' },
  'operacao-retirada': { icon: 'output' },
  'consulta-caracteristicas': { icon: 'find_in_page', label: 'Créditos Registrados' },
  'consulta-operacoes': { icon: 'manage_search', label: 'Operações Realizadas' },
  'consulta-posicao': { icon: 'account_balance', label: 'Posição de Créditos' },
  'registro-projeto': { icon: 'post_add' },
  'validacao-projeto-credito': { icon: 'fact_check', label: 'Validar' },
  'consulta-projeto': { icon: 'search', label: 'Consulta' },
  'registro-emissao-credito': { icon: 'note_add', label: 'Emitir' },
  'confirma-emissao-credito': { icon: 'verified', label: 'Verificar' },
  'consulta-emissao-credito': { icon: 'search', label: 'Consulta' },
};

export const HOME_SEARCH_LINK_PRESENTATION: Record<string, { icon: string; label: string }> = {
  'consulta-projeto': { icon: 'folder_open', label: 'Consultar Projetos Registrados' },
  'consulta-emissao-credito': { icon: 'receipt_long', label: 'Consultar Crédito Emitidos' },
  'consulta-caracteristicas': { icon: 'credit_card', label: 'Consultar Créditos Registrados' },
  'consulta-operacoes': { icon: 'swap_horiz', label: 'Consultar Operações de Créditos' },
  'consulta-posicao': { icon: 'account_balance', label: 'Consultar Posição de Créditos' },
};

export const HOME_SEARCH_GROUPS: Array<{ id: string; title: string; links: string[] }> = [
  {
    id: 'projects-repository',
    title: 'Repositório de Projetos',
    links: ['consulta-projeto', 'consulta-emissao-credito'],
  },
  {
    id: 'b3-register',
    title: 'Registro B3',
    links: ['consulta-caracteristicas', 'consulta-operacoes', 'consulta-posicao'],
  },
];
